import {eTipoPermissao} from '@/enums/ePermissoes';
export default [
 {
  description: 'Tipo de Provento/Desconto Variável',
  path: '/pessoal/pestipoproventovariavel',
  name: 'pestipoproventovariavel',
  component: () => import('@/views/pessoal/pestipoproventovariavel/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.TIPODEPROVENTODESCONTOVARIAVELNOVO_MENU_1400801059],
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Tipo de Provento/Desconto Variável',
  path: '/pessoal/pestipoproventovariavel/cadastro/:id?',
  parent: 'pestipoproventovariavel',
  name: 'pestipoproventovariavel_create',
  component: () => import('@/views/pessoal/pestipoproventovariavel/InclusaoEdicao.vue'),
  meta: {
   permissions: [eTipoPermissao.TIPODEPROVENTODESCONTOVARIAVELNOVO_MENU_1400801059],
  },
  goesToMenu: true,
 },
]
